export { default } from "./ViewPrivacyPolicy";
